import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserIdleConfig, UserIdleModule } from 'angular-user-idle';
import { CreNgConfig, CreNgModule, IdleDialogModule, NotificationModule } from 'cre-ng';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { ApplyNowModule } from '@app/apply-now';
import { CoreModule } from '@app/core';
import { HomeModule } from '@app/home';
import { JobsModule } from '@app/jobs';
import { OverviewModule } from '@app/overview';
import { SharedModule } from '@app/shared';
import { RestInterceptor } from './core/rest.interceptor';

export const creNgConfig: CreNgConfig = {
  idleCheck: window.__env.ngSettings.idleCheck,
  idleSeconds: window.__env.ngSettings.idleSeconds,
  idleTimeout: window.__env.ngSettings.idleTimeout,
  serviceApiDomain:
    window.location.hostname === 'localhost'
      ? 'https://dev.apps.crengland.com'
      : window.location.origin,
  session: window.__env.ngSettings.session,
  sessionAppName: window.__env.ngSettings.sessionAppName,
  sessionSeconds: window.__env.ngSettings.sessionSeconds,
};

const userIdleConfig: UserIdleConfig = {
  idle: creNgConfig.idleSeconds,
  timeout: creNgConfig.idleTimeout,
  ping: 0,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    ApplyNowModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    CreNgModule.forRoot(creNgConfig),
    HomeModule,
    IdleDialogModule,
    JobsModule,
    NotificationModule,
    OverviewModule,
    SharedModule,
    UserIdleModule.forRoot(userIdleConfig),
    AppRoutingModule,
  ],
  providers: [
    {
      provide: CreNgConfig,
      useValue: creNgConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestInterceptor,
      multi: true,
    },
    {
      provide: UserIdleConfig,
      useValue: userIdleConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
